/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const listSessionsParamsUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const listSessionsParamsCursorMax = 512;

export const listSessionsParamsCursorRegExp = new RegExp('^[A-Za-z0-9_-]+$');
export const listSessionsParamsLimitDefault = 50;
export const listSessionsParamsLimitMax = 100;

export const ListSessionsParams = zod.object({
  userId: zod.uuid().regex(listSessionsParamsUserIdRegExp).optional(),
  cursor: zod
    .string()
    .min(1)
    .max(listSessionsParamsCursorMax)
    .regex(listSessionsParamsCursorRegExp)
    .optional(),
  limit: zod.int().min(1).max(listSessionsParamsLimitMax).default(listSessionsParamsLimitDefault),
});

export type ListSessionsParams = zod.input<typeof ListSessionsParams>;
export type ListSessionsParamsOutput = zod.output<typeof ListSessionsParams>;
